(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["razeb-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('RazebWelcomePopup');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    try {
      if (sessionStorage.getItem('razebWelcomePopupSeen') === '1') return;
    } catch (error) {}

    const rememberDismissal = () => {
      try {
        sessionStorage.setItem('razebWelcomePopupSeen', '1');
      } catch (error) {}
    };

    dialog.addEventListener('close', rememberDismissal);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    window.setTimeout(() => {
      if (!dialog.open) dialog.showModal();
    }, 1400);
  })();
  } catch(e) { console.error(e); }
})();

})();
